import forge from "node-forge";
import {
  WithdrawalType,
  Currency,
  currenciesConfig,
  BeneficiaryType,
} from "../constants";
import { TransactionState } from "../contexts/TransactionContext";
import { WithdrawalRequest } from "../services/queries/wallets/types";
// Centralized business rules
export const payoutRules = {
  minimumAmounts: {
    [WithdrawalType.LOCAL]: {
      [Currency.NGN]: 500,
    },
    [WithdrawalType.INTERNATIONAL]: {
      [Currency.NGN]: 5000,
      [Currency.USD]: 100,
    },
  },
};

export enum WalletStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export interface PayoutConfig {
  id: string;
  currency: string;
  fee: number;
  feeCurrency: string;
  minimumAmount: number;
  maximumAmount: number;
}

export function encryptPinClient(pin: string, pem: string): string {
  const publicKey = forge.pki.publicKeyFromPem(pem);
  const encrypted = publicKey.encrypt(pin, "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });
  return forge.util.encode64(encrypted);
}

export const buildWithdrawalRequest = (
  publicKeyPem: string,
  {
    baseCurrency,
    quoteCurrency,
    baseAmount,
    rateId,
    withdrawalType,
    accountName,
    accountNumber,
    bankCode,
    bankName,
    paymentMethod,
    saveBeneficiary,
    pin,
    remarks,
  }: TransactionState,
): WithdrawalRequest => {
  if (!paymentMethod) throw new Error("Payment method not found");
  if (!bankCode) throw new Error("Bank code not found");
  if (!accountName) throw new Error("Account name not found");
  if (!accountNumber) throw new Error("Account number not found");
  if (!bankName) throw new Error("Bank name not found");

  const currency =
    withdrawalType === WithdrawalType.INTERNATIONAL
      ? quoteCurrency
      : baseCurrency;

  if (!currency) throw new Error("Currency not found");

  const countryCode = currenciesConfig.find(
    (item) => item.currency === currency,
  )?.countryCode;

  if (!countryCode) throw new Error("Country code not found");

  const encryptedPin = encryptPinClient(pin, publicKeyPem);

  const request: WithdrawalRequest = {
    amount: Number(baseAmount),
    withdrawalType,
    beneficiary: {
      beneficiaryType: BeneficiaryType.PERSONAL,
      paymentMethod,
      accountName,
      accountNumber,
      bankCode,
      bankName,
      countryCode,
      currencyCode: currency,
    },
    saveBeneficiary,
    pin: encryptedPin,
    remarks,
  };

  if (withdrawalType === WithdrawalType.INTERNATIONAL) {
    request.rateId = rateId;
  }

  return request;
};
